import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface SurveySendIconProps {
  color?: string;
  style?: React.CSSProperties;
}

export const SurveySendIcon = ({ color = RoutalPalette.white, style = {}, ...props }: SurveySendIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 15 16" style={{ width: `15px`, height: `16px`, ...style }}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8014 1.56995C14.9398 1.17454 14.5597 0.79445 14.1643 0.932844L0.33484 5.77316C-0.0925794 5.92276 -0.116867 6.51808 0.296946 6.702L5.85599 9.17268L10.0609 4.96815C10.2562 4.7729 10.5728 4.77291 10.768 4.96818C10.9633 5.16346 10.9633 5.48004 10.768 5.67529L6.56251 9.88037L9.03227 15.4373C9.21619 15.8511 9.81151 15.8268 9.9611 15.3994L14.8014 1.56995Z"
        fill={RoutalPalette.white}
      />
    </SvgIcon>
  );
};
